import * as React from 'react';
import { ElementEnum } from '@bumble/proto/hotpanel';

import { PageFooter } from 'components/badoo/page';
import { useHotpanelClickHandler } from 'lib/hotpanel/hooks/use-hotpanel-click-handler';
import { useGlobalProps } from 'lib/hooks/use-global-props';

export const LandingFooterContainer: React.FC = () => {
    const { lang } = useGlobalProps();

    return (
        <PageFooter
            onBlogClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_BLOG,
                ElementEnum.ELEMENT_FOOTER
            )}
            onCareersClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_CAREERS,
                ElementEnum.ELEMENT_FOOTER
            )}
            onSafetyCentreClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_SAFETY_CENTER,
                ElementEnum.ELEMENT_FOOTER
            )}
            onHelpCentreClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_HELP_CENTRE,
                ElementEnum.ELEMENT_FOOTER
            )}
            onCitiesClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_DATING_CITIES,
                ElementEnum.ELEMENT_FOOTER
            )}
            onChatClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_CHAT,
                ElementEnum.ELEMENT_FOOTER
            )}
            onTermsClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_TERMS_AND_CONDITIONS,
                ElementEnum.ELEMENT_FOOTER
            )}
            onPrivacyClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_PRIVACY_POLICY,
                ElementEnum.ELEMENT_FOOTER
            )}
            onCookiePolicyClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_COOKIES_DETAILS_LINK,
                ElementEnum.ELEMENT_FOOTER
            )}
            onModernSlaveryActClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_MODERN_SLAVERY_STATEMENT,
                ElementEnum.ELEMENT_FOOTER
            )}
            onFacebookClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_APPSTORE,
                ElementEnum.ELEMENT_FOOTER
            )}
            onInstagramClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_INSTAGRAM,
                ElementEnum.ELEMENT_FOOTER
            )}
            onLinkedInClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_LINKEDIN,
                ElementEnum.ELEMENT_FOOTER
            )}
            onTwitterClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_TWITTER,
                ElementEnum.ELEMENT_FOOTER
            )}
            onAppleStoreClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_APPSTORE,
                ElementEnum.ELEMENT_FOOTER
            )}
            onGoogleStoreClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_GOOGLE_PLAY,
                ElementEnum.ELEMENT_FOOTER
            )}
            onHuaweiAppGalleryClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_HUAWEI_APPSTORE,
                ElementEnum.ELEMENT_FOOTER
            )}
            currentLanguage={lang}
        />
    );
};
